import { ArrowLeftOutlined } from "@ant-design/icons";
import { Button, Flex, Result } from "antd";
import { t } from "i18next";
import { useEffect } from "react";
import {
  NavigationType,
  useNavigate,
  useNavigationType,
} from "react-router-dom";
import DownloadProductionCodeRequestFileButton from "../components/DownloadProductionCodesButton/DownloadProductionCodeRequestFileButton";
import style from "./ProductionCodeCreationSuccessPage.module.scss";

const ProductionCodeCreationSuccessPage = () => {
  const navigate = useNavigate();
  const navigationType = useNavigationType();
  const queryParams = new URLSearchParams(window.location.search);
  const productionCodeRequestId = Number(queryParams.get("id"));
  const productionCodeRequestNumber = queryParams.get("brojZahteva");
  const sifraRobneMarke = queryParams.get("sifraRobneMarke");

  const handleGoToProductionCodeRequestList = () => {
    navigate("/obveznik/produkcioniKodovi/listaProdukcionihKodova");
  };

  useEffect(() => {
    if (!productionCodeRequestId || navigationType === NavigationType.Pop) {
      handleGoToProductionCodeRequestList();
    }
  }, [productionCodeRequestId, navigationType]);

  return (
    <Flex
      align="center"
      justify="center"
      style={{ height: "100%" }}
      className={style.stepAnimation}
    >
      <Result
        status="success"
        title={<span className={style.title}>{t("TOAST.UPDATE_QR")}</span>}
        extra={[
          <Button
            key="goBackButton"
            icon={<ArrowLeftOutlined />}
            onClick={handleGoToProductionCodeRequestList}
            className={style.fontSize}
            style={{ border: "none", boxShadow: "unset" }}
          >
            {t("QR_CODE.NAZAD_NA_LISTU_ZAHTEVA")}
          </Button>,
          <DownloadProductionCodeRequestFileButton
            type="proformaInvoice"
            key="downloadProformaInvoiceButton"
            id={productionCodeRequestId}
            docName={productionCodeRequestNumber}
            sifraRobneMarke={sifraRobneMarke}
          />,
        ]}
      />
    </Flex>
  );
};

export default ProductionCodeCreationSuccessPage;
